import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routing } from './Routing';
import store from './store';

const App: React.FC = () => {
  return (
    <Provider {...{ store }}>
      <Router>
        <Routing />
      </Router>
    </Provider>
  );
};

export default App;
